import { Content } from './Content';
import { BackgroundPage } from '@/components/Layout/BackgroundPage';

export function ForgotPassword() {
	return (
		<BackgroundPage>
			<Content />
		</BackgroundPage>
	);
}
